var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKarmen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81025 15.6568C4.06628 14.9148 3.47628 14.033 3.07415 13.0622C2.67203 12.0914 2.46571 11.0508 2.46705 10C2.46705 5.5816 6.04865 2 10.467 2C14.8854 2 18.467 5.5816 18.467 10C18.467 14.4184 14.8854 18 10.467 18H2.46705L4.81025 15.6568ZM7.26705 10.8C7.26705 11.6487 7.60419 12.4626 8.20431 13.0627C8.80442 13.6629 9.61835 14 10.467 14C11.3157 14 12.1297 13.6629 12.7298 13.0627C13.3299 12.4626 13.667 11.6487 13.667 10.8H7.26705Z",
    fill: "current-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarmen);
export default __webpack_public_path__ + "static/media/karmen.107dcd53.svg";
export { ForwardRef as ReactComponent };